/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 15:10:44                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:12:47                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import { validator } from "../../../services/form-validator/form-validator";
import ColorSelector from "../color/ColorSelect";
/***/

/* Validator */
export const TechnicianAttributesFormValidator = {
  phone: (e: unknown) => validator.isString(e)
};

const v = TechnicianAttributesFormValidator; // shorthand
/***/

export default function TechnicianAttributesForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.TechnicianAttributes,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
  return (
    <>
      <div className="field">
        <label>{t("Phone")} *</label>

        <input type="text"
                value={data?.phone || ""}
                onChange={(e) => onChange("phone", e.target.value)}
                className={`${(submitted && !validator.isFieldValid(data, "phone", v)) && "error"}`}
                placeholder={t("Phone")}/>
      </div>

      <div className="field color-field">
        <label>{t("Color")} *</label>

        <ColorSelector  value={data?.color}
                        onChange={(e) => onChange("color", e)}/>
      </div>
    </>
  );
}
